import { render } from "./App.vue?vue&type=template&id=2bb26a7e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2bb26a7e&lang=less"

import exportComponent from "D:\\createProject\\吉幼美官网\\web\\project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__